/* eslint-disable react/prop-types */ // TODO: add props
import { IndicatorCell, INDICATOR_TYPES } from '../../../../../components';
import { RowExpansionArrow } from '../../../components/Icons';
import { NumberOnImageQuestion } from 'edrolo/domains/exams/components/Question/components/NumberOnImageQuestion';
import {
  correctableQuestionPropTypes,
  CorrectableQuestionReview,
} from './CorrectableQuestionReview';
import {
  name,
  selfReflection,
} from '../../../components/TableColumns/TableColumns';
import style from './styles.scss';

const NumberOnImageQuestionReview = ({
  question,
  solution,
  responses,
  highlightProfileId,
  studentCourseProgUrl,
  classStudentProfiles,
}) => {
  const expander = {
    id: 'expander',
    Header: '',
    style: { width: '3%' },
    Cell: ({ row }) =>
      row.original.getIn(['response', 'field_responses', 0]) ? (
        <div
          className={style.expanderWidgetContainer}
          {...row.getToggleRowExpandedProps()}
        >
          {row.isExpanded ? (
            <RowExpansionArrow expanded />
          ) : (
            <RowExpansionArrow />
          )}
        </div>
      ) : null,
  };

  const studentResponseColumn = {
    id: 'studentResponse',
    Header: 'Student Response',
    accessor: (row) => {
      return {
        response: row.get('response'),
      };
    },

    Cell: ({ cell, row }) => {
      const { response } = cell.value;

      return response && response.get('field_responses').size > 0 ? (
        <div {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <div className={style.responseWrapper}>
              <NumberOnImageQuestion
                question={question}
                response={response}
                isQuestionReview
              />
            </div>
          ) : (
            <div className={style.responseWrapper}>
              <span>View student response</span>
            </div>
          )}
        </div>
      ) : (
        <IndicatorCell
          value={'Not answered'}
          indicatorType={INDICATOR_TYPES.NEUTRAL}
        />
      );
    },

    sortType: (rowA, rowB) => {
      let isAnsweredA = null;
      let isAnsweredB = null;
      const responseA = rowA.original.get('response');
      const responseB = rowB.original.get('response');

      if (responseA && responseA.get('field_responses').size > 0) {
        isAnsweredA = true;
      }
      if (responseB && responseB.get('field_responses').size > 0) {
        isAnsweredB = true;
      }

      const isCorrectSortOrder = [true, null];

      if (
        isCorrectSortOrder.indexOf(isAnsweredA) >
        isCorrectSortOrder.indexOf(isAnsweredB)
      ) {
        return 1;
      }

      return -1;
    },
  };

  const answeredCorrectly = {
    id: 'answeredCorrectly',
    Header: 'Answered correctly',
    accessor: (row) => {
      return row.getIn(['response', 'field_responses', 0])
        ? `${row.get('correct') ? 'Yes' : 'No'}`
        : 'Not answered ';
    },

    Cell: (cell) =>
      cell.row.original.getIn(['response', 'field_responses', 0]) ? (
        <IndicatorCell
          value={cell.value}
          indicatorType={
            cell.row.original.get('correct')
              ? INDICATOR_TYPES.POSITIVE
              : INDICATOR_TYPES.NEGATIVE
          }
        />
      ) : (
        <IndicatorCell
          value={cell.value}
          indicatorType={INDICATOR_TYPES.NEUTRAL}
        />
      ),

    sortType: (rowA, rowB) => {
      let isCorrectA = null;
      let isCorrectB = null;
      const responseA = rowA.original.get('response');
      const responseB = rowB.original.get('response');

      if (responseA && responseA.get('field_responses').size > 0) {
        isCorrectA = rowA.original.get('correct');
      }
      if (responseB && responseB.get('field_responses').size > 0) {
        isCorrectB = rowB.original.get('correct');
      }

      const isCorrectSortOrder = [true, false, null];

      if (
        isCorrectSortOrder.indexOf(isCorrectA) >
        isCorrectSortOrder.indexOf(isCorrectB)
      ) {
        return 1;
      }

      return -1;
    },
  };

  return (
    <CorrectableQuestionReview
      question={question}
      solution={solution}
      responses={responses}
      highlightProfileId={highlightProfileId}
      studentCourseProgUrl={studentCourseProgUrl}
      classStudentProfiles={classStudentProfiles}
      nameColumn={{
        ...name(studentCourseProgUrl),
        style: { width: '20%' },
      }}
      studentResponseColumnSpec={{
        ...studentResponseColumn,
        style: { width: '30%' },
      }}
      answeredCorrectlyColumn={{
        ...answeredCorrectly,
        style: { width: '12%' },
      }}
      selfReflectionColumn={{ ...selfReflection, style: { width: '12%' } }}
      expanderColumn={expander}
      checklist
      showChart
      showCorrectness
    />
  );
};

export default NumberOnImageQuestionReview;

NumberOnImageQuestionReview.propTypes = correctableQuestionPropTypes;
